//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import InputField from '../fields/InputField.vue';
export default {
  name: 'GegevensWijzigen',
  components: {
    InputField,
  },
  props: {
    expert: String,
    ajax: String,
  },
  data: function(){
    return {
      loading: true,
      success: false,
      error: false,
      first_name: {
        value: '',
        error: '',
      },
      last_name: {
        value: '',
        error: '',
      },
      telefoonnummer: {
        value: '',
        error: '',
      },
      email: {
        value: '',
        error: '',
      },
      bedrijfsnaam: {
        value: '',
        error: '',
      },
      kvk: {
        value: '',
        error: '',
      },
      btw: {
        value: '',
        error: '',
      },
      iban: {
        value: '',
        error: '',
      },
      adres: {
        value: '',
        error: '',
      },
      postcode: {
        value: '',
        error: '',
      },
      plaats: {
        value: '',
        error: '',
      },
    };
  },
  methods: {
    handleSubmit: function(e){
      e.preventDefault();

      this.success = false;
      this.error = false;

      const { first_name, last_name, email, telefoonnummer, bedrijfsnaam, kvk, btw, iban, adres, postcode, plaats } = this;

      if(first_name.value == ''){
        first_name.error = 'Voornaam is verplicht.';
        this.error = true;
      } else {
        first_name.error = '';
      }

      if(last_name.value == ''){
        last_name.error = 'Achternaam is verplicht.';
        this.error = true;
      } else {
        last_name.error = '';
      }

      if(email.value == ''){
        email.error = 'Email is verplicht.';
        this.error = true;
      } else {
        email.error = '';
      }

      if(telefoonnummer.value == ''){
        telefoonnummer.error = 'Telefoonnummer is verplicht.';
        this.error = true;
      } else {
        telefoonnummer.error = '';
      }

      if(bedrijfsnaam.value == ''){
        bedrijfsnaam.error = 'Bedrijfsnaam is verplicht.';
        this.error = true;
      } else {
        bedrijfsnaam.error = '';
      }

      if(kvk.value == ''){
        kvk.error = 'KVK nummer is verplicht.';
        this.error = true;
      } else {
        kvk.error = '';
      }

      if(btw.value == ''){
        btw.error = 'BTW nummer is verplicht.';
        this.error = true;
      } else {
        btw.error = '';
      }

      if(iban.value == ''){
        iban.error = 'IBAN is verplicht.';
        this.error = true;
      } else {
        iban.error = '';
      }

      if(adres.value == ''){
        adres.error = 'Adres is verplicht.';
        this.error = true;
      } else {
        adres.error = '';
      }

      if(postcode.value == ''){
        postcode.error = 'Postcode is verplicht.';
        this.error = true;
      } else {
        postcode.error = '';
      }

      if(plaats.value == ''){
        plaats.error = 'Plaats is verplicht.';
        this.error = true;
      } else {
        plaats.error = '';
      }

      if(this.error){
        return false;
      }

      const formData = new FormData();
      formData.append('first_name', first_name.value);
      formData.append('last_name', last_name.value);
      formData.append('email', email.value);
      formData.append('telefoonnummer', telefoonnummer.value);
      formData.append('bedrijfsnaam', bedrijfsnaam.value);
      formData.append('kvk', kvk.value);
      formData.append('btw', btw.value);
      formData.append('iban', iban.value);
      formData.append('adres', adres.value);
      formData.append('postcode', postcode.value);
      formData.append('plaats', plaats.value);

      axios({
        method: 'post',
        url: `${this.ajax}?action=update_current_user`,
        data: formData,
        headers: {
          'Content-type': 'application/json',
        },
      }).then(() => {
        this.success = true;
      }).catch(() => {
        this.error = true;
      });
    },
  },
  created: function() {
    this.loading = true;
    axios.get(`${this.ajax}?action=current_user`).then(res => {
      const user = res.data;
      this.first_name.value = user.first_name;
      this.last_name.value = user.last_name;
      this.email.value = user.email;
      this.telefoonnummer.value = user.telefoonnummer;
      this.bedrijfsnaam.value = user.bedrijfsnaam;
      this.kvk.value = user.kvk;
      this.btw.value = user.btw;
      this.iban.value = user.iban;
      this.adres.value = user.adres;
      this.postcode.value = user.postcode;
      this.plaats.value = user.plaats;
      this.loading = false;
    }).catch(error => {
      console.log(error);
      this.loading = false;
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/MijnAccount/GegevensWijzigen.vue